export const tableGroupedHeader = [
  {
    key: "Company",
    label: "Company",
    sortable: true,
    style: {
      width: "20%",
    },
  },
  {
    key: "Email",
    label: "Company Email",
    sortable: true,
    style: {
      width: "30%",
    },
    hideCollapsed: true,
  },
  {
    key: "Description",
    label: "Description",
    sortable: false,
    style: {
      width: "30%",
    },
    hideCollapsed: true,
  },
  {
    key: "Age",
    label: "Age",
    sortable: true,
    style: {
      width: "10%",
    },
    hideCollapsed: true,
  },
  {
    key: "Costs",
    label: "Costs",
    sortable: true,
    style: {
      width: "10%",
    },
  },
];

export const tableGrouped: object[] = [
  {
    Description: null,
    Email: null,
    Age: 22,
    Costs: "2.38",
    Company: null,
    Name: "Blaine M. Slater",
  },
  {
    Description: null,
    Email: null,
    Age: 35,
    Costs: "9.11",
    Company: null,
    Name: "Hollee Mcneil",
  },
  {
    Description: "Phasellus in felis.",
    Email: null,
    Age: 22,
    Costs: "69.08",
    Company: null,
    Name: "Yolanda Torres",
  },
  {
    Description: "ultrices. Duis volutpat",
    Email: "Quisque.ornare.tortor@Proin.co.uk",
    Age: 40,
    Costs: "4.78",
    Company: "null",
    Name: "Mohammad Newton",
  },
  {
    Description: "ultricies sem magna",
    Email: "mauris@acfermentumvel.ca",
    Age: 32,
    Costs: "7.05",
    Company: "Natoque Consulting",
    Name: "Drew Black",
  },
  {
    Description: "urna. Vivamus molestie",
    Email: 1,
    Age: 33,
    Costs: "54.28",
    Company: "Natoque Consulting",
    Name: "Brittany Melendez",
  },
  {
    Description: "ante, iaculis nec,",
    Email: "",
    Age: 40,
    Costs: "97.84",
    Company: "Natoque Consulting",
    Name: "Skyler Carson",
  },
  {
    Description: "auctor quis, tristique",
    Email: "",
    Age: 31,
    Costs: "70.51",
    Company: "Natoque Consulting",
    Name: "Jacqueline Cooper",
  },
  {
    Description: "arcu. Vestibulum ut",
    Email: "",
    Age: 20,
    Costs: "25.68",
    Company: "Natoque Consulting",
    Name: "Blossom Lester",
  },
  {
    Description: "augue id ante",
    Email: "",
    Age: 27,
    Costs: "77.09",
    Company: "Natoque Consulting",
    Name: "Ciaran V. Jones",
  },
  {
    Description: "Nullam vitae diam.",
    Email: "",
    Age: 40,
    Costs: "47.37",
    Company: "Metus Vitae Ltd",
    Name: "Bruno Suarez",
  },
  {
    Description: "sagittis lobortis mauris.",
    Email: "",
    Age: 46,
    Costs: "65.23",
    Company: "Metus Vitae Ltd",
    Name: "Darryl N. Baker",
  },
  {
    Description: "tincidunt. Donec vitae",
    Email: "vel.nisl@arcu.edu",
    Age: 36,
    Costs: "81.90",
    Company: "Metus Vitae Ltd",
    Name: "Flavia Drake",
  },
  {
    Description: "eget magna. Suspendisse",
    Email: "",
    Age: 30,
    Costs: "3.53",
    Company: "Metus Vitae Ltd",
    Name: "Jade S. Terrell",
  },
  {
    Description: "porttitor vulputate, posuere",
    Email: "",
    Age: 39,
    Costs: "51.59",
    Company: "Metus Vitae Ltd",
    Name: "Reuben Mooney",
  },
  {
    Description: "aliquam, enim nec",
    Email: "non.sollicitudin.a@urnajusto.ca",
    Age: 44,
    Costs: "52.68",
    Company: "Metus Vitae Ltd",
    Name: "Brody Dejesus",
  },
  {
    Description: "sed orci lobortis",
    Email: "",
    Age: 24,
    Costs: "48.16",
    Company: "Metus Vitae Ltd",
    Name: "Calvin Lamb",
  },
  {
    Description: "Donec egestas. Aliquam",
    Email: "",
    Age: 42,
    Costs: "26.27",
    Company: "Metus Vitae Ltd",
    Name: "Winter Santos",
  },
  {
    Description: "vitae sodales nisi",
    Email: "",
    Age: 23,
    Costs: "32.14",
    Company: "Metus Vitae Ltd",
    Name: "Mufutau Hurst",
  },
  {
    Description: "justo faucibus lectus,",
    Email: "et.lacinia.vitae@urnanecluctus.org",
    Age: 48,
    Costs: "59.86",
    Company: "Metus Vitae Ltd",
    Name: "Shad Dixon",
  },
  {
    Description: "id magna et",
    Email: "",
    Age: 46,
    Costs: "37.15",
    Company: "In Industries",
    Name: "Carson I. Moody",
  },
  {
    Description: "mauris. Suspendisse aliquet",
    Email: "non.bibendum.sed@congue.net",
    Age: 46,
    Costs: "62.19",
    Company: "In Industries",
    Name: "Benjamin Dennis",
  },
  {
    Description: "erat semper rutrum.",
    Email: "erat@a.org",
    Age: 40,
    Costs: "48.54",
    Company: "In Industries",
    Name: "Noble J. Rodriguez",
  },
  {
    Description: "ornare. Fusce mollis.",
    Email: "libero.Donec@euligula.co.uk",
    Age: 32,
    Costs: "85.98",
    Company: "In Industries",
    Name: "Rama M. Irwin",
  },
  {
    Description: "adipiscing elit. Etiam",
    Email: "non.bibendum.sed@Maurisnulla.com",
    Age: 41,
    Costs: "73.50",
    Company: "In Industries",
    Name: "Kaseem Jackson",
  },
  {
    Description: "auctor, nunc nulla",
    Email: "ante@Loremipsum.com",
    Age: 37,
    Costs: "80.49",
    Company: "In Industries",
    Name: "Talon U. Rice",
  },
  {
    Description: "scelerisque sed, sapien.",
    Email: "nunc.Quisque.ornare@Aliquamadipiscing.edu",
    Age: 42,
    Costs: "53.38",
    Company: "In Industries",
    Name: "Shelby V. Reid",
  },
  {
    Description: "adipiscing, enim mi",
    Email: "eget.volutpat.ornare@magnisdis.com",
    Age: 41,
    Costs: "40.53",
    Company: "In Industries",
    Name: "Odysseus Dixon",
  },
  {
    Description: "lacus pede sagittis",
    Email: "tristique.neque@Mauriseu.co.uk",
    Age: 40,
    Costs: "31.57",
    Company: "In Industries",
    Name: "Elliott E. Kelly",
  },
  {
    Description: "lectus rutrum urna,",
    Email: "dictum.sapien@mollisDuissit.com",
    Age: 31,
    Costs: "84.90",
    Company: "In Industries",
    Name: "Evangeline Trujillo",
  },
  {
    Description: "dis parturient montes,",
    Email: "tempor@lacusCras.edu",
    Age: 33,
    Costs: "36.81",
    Company: "Ut Tincidunt Ltd",
    Name: "Constance Y. Mcdonald",
  },
  {
    Description: "pede sagittis augue,",
    Email: "montes.nascetur@Crasvehiculaaliquet.org",
    Age: 35,
    Costs: "28.99",
    Company: "Ut Tincidunt Ltd",
    Name: "Ann J. Caldwell",
  },
  {
    Description: "eu sem. Pellentesque",
    Email: "a.magna.Lorem@gravida.org",
    Age: 31,
    Costs: "88.80",
    Company: "Ut Tincidunt Ltd",
    Name: "Mariko O. Pace",
  },
  {
    Description: "egestas a, dui.",
    Email: "Nam.consequat@liberoestcongue.org",
    Age: 39,
    Costs: "25.22",
    Company: "Ut Tincidunt Ltd",
    Name: "Fuller Hernandez",
  },
  {
    Description: "Cras sed leo.",
    Email: "Vivamus.molestie@rhoncusidmollis.edu",
    Age: 29,
    Costs: "84.06",
    Company: "Ut Tincidunt Ltd",
    Name: "Indigo Q. Rios",
  },
  {
    Description: "tempor bibendum. Donec",
    Email: "mi.fringilla.mi@anteblanditviverra.org",
    Age: 42,
    Costs: "71.17",
    Company: "Ut Tincidunt Ltd",
    Name: "Daquan Lawson",
  },
  {
    Description: "adipiscing non, luctus",
    Email: "cubilia@ornarelectus.co.uk",
    Age: 45,
    Costs: "12.75",
    Company: "Ut Tincidunt Ltd",
    Name: "Sydney Hess",
  },
  {
    Description: "consectetuer, cursus et,",
    Email: "Proin.ultrices@penatibusetmagnis.com",
    Age: 38,
    Costs: "26.11",
    Company: "Ut Tincidunt Ltd",
    Name: "Maia Bell",
  },
  {
    Description: "lorem fringilla ornare",
    Email: "Praesent@malesuadafames.com",
    Age: 44,
    Costs: "70.79",
    Company: "Ut Tincidunt Ltd",
    Name: "Warren D. Pickett",
  },
  {
    Description: "ut aliquam iaculis,",
    Email: "quis.tristique@vel.edu",
    Age: 29,
    Costs: "76.76",
    Company: "Ut Tincidunt Ltd",
    Name: "Kasimir Sweet",
  },
  {
    Description: "urna, nec luctus",
    Email: "magna.Phasellus@ipsumprimis.edu",
    Age: 41,
    Costs: "93.61",
    Company: "Est Consulting",
    Name: "Cassady I. Sexton",
  },
  {
    Description: "sed tortor. Integer",
    Email: "Nulla@Quisque.edu",
    Age: 21,
    Costs: "30.23",
    Company: "Est Consulting",
    Name: "Ignacia T. Leblanc",
  },
  {
    Description: "ante bibendum ullamcorper.",
    Email: "Donec.at@blandit.edu",
    Age: 30,
    Costs: "49.39",
    Company: "Est Consulting",
    Name: "McKenzie Ferrell",
  },
  {
    Description: "auctor odio a",
    Email: "eu@vulputaterisus.com",
    Age: 50,
    Costs: "22.15",
    Company: "Est Consulting",
    Name: "Madaline D. Valentine",
  },
  {
    Description: "lacinia at, iaculis",
    Email: "montes.nascetur@non.co.uk",
    Age: 36,
    Costs: "44.99",
    Company: "Est Consulting",
    Name: "Rosalyn Hewitt",
  },
  {
    Description: "ipsum sodales purus,",
    Email: "tempus.eu@libero.org",
    Age: 39,
    Costs: "43.66",
    Company: "Est Consulting",
    Name: "Fritz Jenkins",
  },
  {
    Description: "in lobortis tellus",
    Email: "Integer@hendreritidante.com",
    Age: 50,
    Costs: "89.78",
    Company: "Est Consulting",
    Name: "Mallory Donaldson",
  },
  {
    Description: "senectus et netus",
    Email: "mollis.Integer.tincidunt@Nam.com",
    Age: 23,
    Costs: "54.33",
    Company: "Est Consulting",
    Name: "Aaron Z. Hutchinson",
  },
  {
    Description: "dis parturient montes,",
    Email: "augue@tincidunt.ca",
    Age: 40,
    Costs: "26.06",
    Company: "Est Consulting",
    Name: "Ivor Hickman",
  },
  {
    Description: "urna convallis erat,",
    Email: "cursus.purus.Nullam@AliquamnislNulla.net",
    Age: 45,
    Costs: "46.78",
    Company: "Est Consulting",
    Name: "Skyler Q. Kaufman",
  },
  {
    Description: "elit fermentum risus,",
    Email: "dis@dui.edu",
    Age: 28,
    Costs: "81.51",
    Company: "Natoque Consulting",
    Name: "Carly X. Kemp",
  },
  {
    Description: "nascetur ridiculus mus.",
    Email: "Donec.egestas.Duis@elitfermentum.ca",
    Age: 40,
    Costs: "98.26",
    Company: "Natoque Consulting",
    Name: "Mufutau C. Nelson",
  },
  {
    Description: "libero. Donec consectetuer",
    Email: "eu.neque.pellentesque@Sednuncest.ca",
    Age: 29,
    Costs: "81.49",
    Company: "Natoque Consulting",
    Name: "Priscilla Puckett",
  },
  {
    Description: "Fusce dolor quam,",
    Email: "et.magna@vitaenibhDonec.com",
    Age: 47,
    Costs: "38.91",
    Company: "Natoque Consulting",
    Name: "Kalia H. Lang",
  },
  {
    Description: "eu tellus eu",
    Email: "mattis.Integer@euodiotristique.edu",
    Age: 29,
    Costs: "47.03",
    Company: "Natoque Consulting",
    Name: "Anthony J. Foster",
  },
  {
    Description: "Nunc mauris sapien,",
    Email: "ac.turpis@famesac.com",
    Age: 37,
    Costs: "36.13",
    Company: "Natoque Consulting",
    Name: "Shea Graham",
  },
  {
    Description: "convallis ligula. Donec",
    Email: "ante@eratvolutpatNulla.com",
    Age: 46,
    Costs: "44.86",
    Company: "Natoque Consulting",
    Name: "Yeo O. Huber",
  },
  {
    Description: "parturient montes, nascetur",
    Email: "Curabitur.ut@miAliquam.ca",
    Age: 25,
    Costs: "17.45",
    Company: "Natoque Consulting",
    Name: "Orli Cantu",
  },
  {
    Description: "est tempor bibendum.",
    Email: "at@enimEtiam.ca",
    Age: 22,
    Costs: "99.59",
    Company: "Natoque Consulting",
    Name: "Sydnee O. Holcomb",
  },
  {
    Description: "orci, adipiscing non,",
    Email: "vitae@viverra.com",
    Age: 48,
    Costs: "53.47",
    Company: "Natoque Consulting",
    Name: "Evelyn Kelly",
  },
  {
    Description: "ac arcu. Nunc",
    Email: "ante@arcueu.org",
    Age: 33,
    Costs: "57.25",
    Company: "Metus Vitae Ltd",
    Name: "Reagan E. Martin",
  },
  {
    Description: "arcu iaculis enim,",
    Email: "elit@orciconsectetuer.com",
    Age: 34,
    Costs: "84.46",
    Company: "Metus Vitae Ltd",
    Name: "Yasir U. Pope",
  },
  {
    Description: "posuere, enim nisl",
    Email: "ipsum.leo@nisiAeneaneget.com",
    Age: 35,
    Costs: "79.55",
    Company: "Metus Vitae Ltd",
    Name: "Cullen Prince",
  },
  {
    Description: "pede, nonummy ut,",
    Email: "natoque@auguemalesuada.com",
    Age: 30,
    Costs: "76.00",
    Company: "Metus Vitae Ltd",
    Name: "Andrew Walls",
  },
  {
    Description: "ornare, lectus ante",
    Email: "amet.risus@augueeu.co.uk",
    Age: 20,
    Costs: "17.99",
    Company: "Metus Vitae Ltd",
    Name: "Ali R. Kim",
  },
  {
    Description: "neque et nunc.",
    Email: "pellentesque.eget@felisegetvarius.co.uk",
    Age: 45,
    Costs: "41.76",
    Company: "Metus Vitae Ltd",
    Name: "Kaitlin Melton",
  },
  {
    Description: "amet orci. Ut",
    Email: "amet@Nunc.edu",
    Age: 39,
    Costs: "58.74",
    Company: "Metus Vitae Ltd",
    Name: "Raja M. Nielsen",
  },
  {
    Description: "lorem ipsum sodales",
    Email: "ante.Maecenas.mi@Maurisnon.co.uk",
    Age: 34,
    Costs: "77.70",
    Company: "Metus Vitae Ltd",
    Name: "Maggy N. Mayer",
  },
  {
    Description: "est. Nunc laoreet",
    Email: "Nulla.facilisis@necenimNunc.net",
    Age: 48,
    Costs: "41.09",
    Company: "Metus Vitae Ltd",
    Name: "Orlando Moses",
  },
  {
    Description: "faucibus orci luctus",
    Email: "tortor.Nunc@dapibusligula.ca",
    Age: 20,
    Costs: "65.97",
    Company: "Metus Vitae Ltd",
    Name: "Whoopi Webster",
  },
  {
    Description: "malesuada vel, convallis",
    Email: "dui@tempusnonlacinia.co.uk",
    Age: 28,
    Costs: "10.23",
    Company: "In Industries",
    Name: "May H. Webb",
  },
  {
    Description: "Nunc ut erat.",
    Email: "sagittis.Duis.gravida@sodalesMauris.net",
    Age: 37,
    Costs: "28.59",
    Company: "In Industries",
    Name: "Lacota F. Mueller",
  },
  {
    Description: "interdum feugiat. Sed",
    Email: "faucibus.orci@magna.ca",
    Age: 46,
    Costs: "94.60",
    Company: "In Industries",
    Name: "Boris Holman",
  },
  {
    Description: "lacus pede sagittis",
    Email: "sem.semper@facilisisfacilisis.com",
    Age: 47,
    Costs: "6.70",
    Company: "In Industries",
    Name: "Chancellor Wolf",
  },
  {
    Description: "Curabitur massa. Vestibulum",
    Email: "Nunc.mauris@Nuncullamcorper.net",
    Age: 46,
    Costs: "51.46",
    Company: "In Industries",
    Name: "MacKenzie Austin",
  },
  {
    Description: "morbi tristique senectus",
    Email: "hendrerit.id@massa.net",
    Age: 40,
    Costs: "81.57",
    Company: "In Industries",
    Name: "Melvin H. Harrington",
  },
  {
    Description: "vestibulum, neque sed",
    Email: "erat.volutpat.Nulla@intempuseu.net",
    Age: 33,
    Costs: "56.35",
    Company: "In Industries",
    Name: "Avram L. Levine",
  },
  {
    Description: "bibendum fermentum metus.",
    Email: "Mauris@eget.edu",
    Age: 44,
    Costs: "98.25",
    Company: "In Industries",
    Name: "Shelby Y. Michael",
  },
  {
    Description: "sit amet diam",
    Email: "amet@risusquis.co.uk",
    Age: 34,
    Costs: "56.28",
    Company: "In Industries",
    Name: "Oliver Griffith",
  },
  {
    Description: "nisi dictum augue",
    Email: "ut.pharetra.sed@erosnectellus.edu",
    Age: 42,
    Costs: "94.07",
    Company: "In Industries",
    Name: "Tanner Day",
  },
  {
    Description: "in molestie tortor",
    Email: "ut@dolor.com",
    Age: 27,
    Costs: "82.54",
    Company: "Ut Tincidunt Ltd",
    Name: "Kibo Sutton",
  },
  {
    Description: "dolor vitae dolor.",
    Email: "Vivamus.sit.amet@tempus.edu",
    Age: 21,
    Costs: "31.23",
    Company: "Ut Tincidunt Ltd",
    Name: "Thor Stone",
  },
  {
    Description: "Cras vehicula aliquet",
    Email: "Aenean@orciDonecnibh.ca",
    Age: 43,
    Costs: "21.66",
    Company: "Ut Tincidunt Ltd",
    Name: "Zenia Kane",
  },
  {
    Description: "sit amet ornare",
    Email: "orci@purus.net",
    Age: 21,
    Costs: "37.45",
    Company: "Ut Tincidunt Ltd",
    Name: "Briar Jordan",
  },
  {
    Description: "nec luctus felis",
    Email: "lacus@blandit.co.uk",
    Age: 24,
    Costs: "38.27",
    Company: "Ut Tincidunt Ltd",
    Name: "Griffin Mullen",
  },
  {
    Description: "et tristique pellentesque,",
    Email: "montes@pretiumnequeMorbi.com",
    Age: 45,
    Costs: "23.20",
    Company: "Ut Tincidunt Ltd",
    Name: "Jamal Alvarez",
  },
  {
    Description: "quis massa. Mauris",
    Email: "quam@non.com",
    Age: 37,
    Costs: "43.99",
    Company: "Ut Tincidunt Ltd",
    Name: "Isabella D. Bradshaw",
  },
  {
    Description: "sodales elit erat",
    Email: "parturient@euduiCum.org",
    Age: 42,
    Costs: "95.36",
    Company: "Ut Tincidunt Ltd",
    Name: "Calista Mccall",
  },
  {
    Description: "feugiat nec, diam.",
    Email: "diam.dictum@semPellentesque.edu",
    Age: 27,
    Costs: "65.79",
    Company: "Ut Tincidunt Ltd",
    Name: "Raymond Mcdonald",
  },
  {
    Description: "Duis cursus, diam",
    Email: "quis@accumsaninterdumlibero.co.uk",
    Age: 41,
    Costs: "31.27",
    Company: "Ut Tincidunt Ltd",
    Name: "Paula X. Castro",
  },
  {
    Description: "arcu vel quam",
    Email: "dolor.egestas@erosNamconsequat.net",
    Age: 47,
    Costs: "42.58",
    Company: "Est Consulting",
    Name: "Xena Snyder",
  },
  {
    Description: "a, arcu. Sed",
    Email: "egestas@Maecenas.net",
    Age: 41,
    Costs: "53.82",
    Company: "Est Consulting",
    Name: "Shana Mccarthy",
  },
  {
    Description: "vel, vulputate eu,",
    Email: "mus@posuere.co.uk",
    Age: 44,
    Costs: "97.95",
    Company: "Est Consulting",
    Name: "Blaze O. Mclean",
  },
  {
    Description: "Integer eu lacus.",
    Email: "vulputate@fermentum.co.uk",
    Age: 34,
    Costs: "74.13",
    Company: "Est Consulting",
    Name: "Sylvester U. Ochoa",
  },
  {
    Description: "ac arcu. Nunc",
    Email: "quam.dignissim@nullaante.edu",
    Age: 33,
    Costs: "54.83",
    Company: "Est Consulting",
    Name: "Tatyana Barnett",
  },
  {
    Description: "dictum cursus. Nunc",
    Email: "nec.tempus.scelerisque@liberoMorbiaccumsan.com",
    Age: 26,
    Costs: "14.37",
    Company: "Est Consulting",
    Name: "Caleb Sparks",
  },
  {
    Description: "Sed eget lacus.",
    Email: "Fusce.feugiat@adipiscingnon.net",
    Age: 24,
    Costs: "94.16",
    Company: "Est Consulting",
    Name: "Francesca Stuart",
  },
  {
    Description: "ante. Vivamus non",
    Email: "mauris@dolor.ca",
    Age: 33,
    Costs: "72.62",
    Company: "Est Consulting",
    Name: "Mufutau Z. Atkins",
  },
  {
    Description: "sed, est. Nunc",
    Email: "et.rutrum@elitpharetraut.org",
    Age: 25,
    Costs: "61.23",
    Company: "Est Consulting",
    Name: "Thor V. Barron",
  },
  {
    Description: "arcu imperdiet ullamcorper.",
    Email: "ac@loremvitaeodio.com",
    Age: 25,
    Costs: "81.08",
    Company: "Est Consulting",
    Name: "Harlan Wall",
  },
];
